import { useContext, useEffect, useState } from 'react';

import { ConfigContext } from 'Context/config';

import { toggleZendeskVerticalOffset, toggleZendeskVisibility } from 'Utilities/zendeskWidget';

export const ZENDESK_EVENT = 'zendeskWidgetLoad';

const ZendeskWidget = () => {
  const { configState: { zendeskWidgetState } } = useContext(ConfigContext);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const handleError = (err) => {
      setLoaded(false);
      window?.Sentry?.captureException(new Error(err), {
        level: 'warning',
      });
      console.error(err); // eslint-disable-line no-console
    };

    if (!loaded && zendeskWidgetState.show) {
      setLoaded(true);

      const s = document.createElement('script');
      s.id = 'ze-snippet';
      s.src = 'https://static.zdassets.com/ekr/snippet.js?key=d5e79e18-889b-41cf-b200-1bb7535acc66';
      s.type = 'text/javascript';
      s.onload = () => {
        const event = new Event(ZENDESK_EVENT);
        document.dispatchEvent(event);
      };
      s.onerror = () => handleError('Zendesk widget script has failed to load');

      document.head.append(s);
    }
  }, [loaded, zendeskWidgetState]);

  useEffect(() => {
    const listenZendesk = () => {
      toggleZendeskVisibility(zendeskWidgetState);
      toggleZendeskVerticalOffset(zendeskWidgetState);
    };

    if (!globalThis?.zE) {
      document.addEventListener(ZENDESK_EVENT, listenZendesk, { once: true });
    }

    return () => document.removeEventListener(ZENDESK_EVENT, listenZendesk, { once: true });
  }, [zendeskWidgetState]);

  useEffect(() => {
    toggleZendeskVisibility(zendeskWidgetState);
    toggleZendeskVerticalOffset(zendeskWidgetState);
  }, [zendeskWidgetState]);

  return (null);
};

export default ZendeskWidget;
